export {default as RouteWithLayout} from './RouteWithLayout';
export {default as ContactForm} from './ContactForm';
export const formatDate = (date) => {
    return new Intl.DateTimeFormat('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    }).format(date)
}

export const showChat = () => {
    $crisp.push(["do", "chat:open"])
}

export const showCookieWidget = () => {
    const n =
        document.querySelectorAll('[data-widget-id="TMtSARvabecRGwkDAjVRh1MK"]')
    if(n && n[0]){
        if(n[0].childNodes && n[0].childNodes.length) {
            n[0].childNodes[0].click()
        }
    }
}

export const showHowToStart = () => {
    window.open('https://www.chargebee.com/docs/revrec/quick-start.html', "_blank");
}

export const showSupport = () => {
    window.open("https://support.chargebee.com/support/home", "_blank")
}

export const showHelp = () => {
    window.open("https://www.chargebee.com/docs/revrec/", "_blank")
}

export const showSignup = () => {
    window.open("https://app.rev-lock.com", "_blank")
}

export const showDemo = () => {
    window.open("https://chargebee-3732359.hs-sites.com/revrec-demo", "_blank")
}

export const showUltimateGuide = () => {
    window.open("https://www.chargebee.com/resources/guides/ASC606-implementation-whitepaper/", "_blank")
}

export const onContact = () => {
    window.open("https://calendly.com/ckirsch/chat", "_blank")
}

export const isEmail = (email) => {
    const emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(email)) {
        return true;
    }
    return false;
}

